const comments = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20young%20Chinese%20person%2C%20warm%20lighting%2C%20friendly%20expression%2C%20clean%20background%2C%20editorial%20quality&width=80&height=80&seq=avatar-01-cg&orientation=squarish',
    name: '吃瓜群众小王',
    time: '2小时前',
    content: '每天必刷51吃瓜网站，更新速度真的快，全网最全的吃瓜入口名不虚传！今天又吃到好几个大瓜，满足～',
    likes: '326',
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20young%20Chinese%20woman%2C%20warm%20lighting%2C%20confident%20expression%2C%20clean%20cream%20background%2C%20editorial%20quality&width=80&height=80&seq=avatar-02-cg&orientation=squarish',
    name: '娱乐圈观察员',
    time: '5小时前',
    content: '作为资深吃瓜人，51吃瓜网在线的整理能力确实一流，时间线清晰、来源标注明确，比那些乱七八糟的自媒体强太多了。',
    likes: '198',
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20young%20Chinese%20man%2C%20warm%20lighting%2C%20casual%20expression%2C%20clean%20cream%20background%2C%20editorial%20quality&width=80&height=80&seq=avatar-03-cg&orientation=squarish',
    name: '今天你吃瓜了吗',
    time: '8小时前',
    content: '51吃瓜APP下载之后简直打开新世界，推送比微博还快！现在同事群里的瓜都是我第一个发的，哈哈。',
    likes: '157',
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20young%20Chinese%20person%2C%20warm%20lighting%2C%20kind%20expression%2C%20clean%20cream%20background%2C%20editorial%20quality&width=80&height=80&seq=avatar-04-cg&orientation=squarish',
    name: '八卦小能手',
    time: '12小时前',
    content: '之前一直找不到靠谱的吃瓜网址，自从发现51吃瓜网站之后就成了忠实用户，内容全、更新快、没广告，良心平台！',
    likes: '89',
  },
  {
    id: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20young%20Chinese%20woman%2C%20warm%20lighting%2C%20happy%20expression%2C%20clean%20cream%20background%2C%20editorial%20quality&width=80&height=80&seq=avatar-05-cg&orientation=squarish',
    name: '深夜吃瓜人',
    time: '18小时前',
    content: '51吃瓜在线观看的体验太好了，视频加载快画质清晰，而且分类很清楚，想找什么类型的瓜都很方便。强烈推荐！',
    likes: '62',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">吃瓜热评</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            来看看其他吃瓜群众怎么说，加入51吃瓜网站的吃瓜大家庭
          </p>
        </div>

        <div className="flex flex-col gap-4">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5"
            >
              <div className="flex items-start gap-3 md:gap-4">
                <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-sm font-medium text-foreground-900">{comment.name}</span>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-2">
                    {comment.content}
                  </p>
                  <div className="flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-thumb-up-line"></i>
                    <span>{comment.likes}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}